import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { requestService } from "../services/goHireService";
import { getServiceRequestPageRoute } from "../../../../routers/routeUtils";

export const useRequestService = (serviceId: number, options?: { onSuccess?: () => void }) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: () => requestService(serviceId),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.all });
      options?.onSuccess?.();
    },
    onError: () => {},
  });
};
